<!-- Just a logical component - no DOM is necessary -->
<template>
  <div v-show="false"/>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data: () => ({
    activeTimeout: null,
    wasInitialized: false,
  }),
  computed: {
    ...mapGetters([
      'activeClass',
      'group',
    ])
  },
  watch: {
    activeClass: {
      handler() {
        this.reinit();
      },
      deep: true
    },
    group: {
      handler() {
        this.reinit();
      },
      deep: true
    },
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    reinit() {
      if (this.activeClass) {
        if (this.activeClass.idleTimeoutSeconds > 0) {
          clearTimeout(this.activeTimeout);
          this.activeTimeout = setTimeout(async() => {
            if (this.activeClass.idleTimeoutSeconds > 0) {
              // eslint-disable-next-line no-alert
              alert('You have been logged out due to inactivity.  The page will now reload.');
              await this.logout();
              window.location.reload();
            }
          }, this.activeClass.idleTimeoutSeconds * 1000);
        }
      } else {
        clearTimeout(this.activeTimeout);
        this.activeTimeout = null;
      }
      this.wasInitialized = true;
    },
    initInputListeners() {
      document.addEventListener('mousedown', this.reinit);
      document.addEventListener('mousemove', this.reinit);
      document.addEventListener('mouseup', this.reinit);

      document.addEventListener('touchstart', this.reinit);
      document.addEventListener('touchmove', this.reinit);
      document.addEventListener('touchend', this.reinit);

      document.addEventListener('keypress', this.reinit);
      document.addEventListener('keydown', this.reinit);
      document.addEventListener('keyup', this.reinit);

      document.addEventListener('DOMMouseScroll', this.reinit);
      document.addEventListener('mousewheel', this.reinit);

      document.addEventListener('click', this.reinit);
      document.addEventListener('scroll', this.reinit);
      document.addEventListener('resize', this.reinit);
    },
    deinitInputListeners() {
      document.removeEventListener('mousedown', this.reinit);
      document.removeEventListener('mousemove', this.reinit);
      document.removeEventListener('mouseup', this.reinit);

      document.removeEventListener('touchstart', this.reinit);
      document.removeEventListener('touchmove', this.reinit);
      document.removeEventListener('touchend', this.reinit);

      document.removeEventListener('keypress', this.reinit);
      document.removeEventListener('keydown', this.reinit);
      document.removeEventListener('keyup', this.reinit);

      document.removeEventListener('DOMMouseScroll', this.reinit);
      document.removeEventListener('mousewheel', this.reinit);

      document.removeEventListener('click', this.reinit);
      document.removeEventListener('scroll', this.reinit);
      document.removeEventListener('resize', this.reinit);
    }
  },
  mounted() {
    this.initInputListeners();
    this.reinit();
  },
  beforeDestroy() {
    this.deinitInputListeners();
    clearTimeout(this.activeTimeout);
    this.activeTimeout = null;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/utility/IdleTimeoutController.vue